import { render, staticRenderFns } from "./QuestionsNumber.vue?vue&type=template&id=b20f9848&scoped=true&"
import script from "./QuestionsNumber.vue?vue&type=script&lang=js&"
export * from "./QuestionsNumber.vue?vue&type=script&lang=js&"
import style0 from "./QuestionsNumber.vue?vue&type=style&index=0&id=b20f9848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b20f9848",
  null
  
)

export default component.exports